import { Component, OnInit } from '@angular/core';
import { BehaviorSubject, concatMap, finalize } from 'rxjs';
import { TranslocoService, TranslocoPipe } from '@jsverse/transloco';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GiftBoxVerifyAddressModalComponent } from '../modals/giftbox-verify-address-modal/verify-address-modal.component';
import { GiftBoxReferralCodeModalComponent } from '../modals/referral-code-modal/referral-code-modal.component';
import { OrderType } from '../../../core/enums';
import { Affiliate, Product, ListContent } from '../../../core/models';
import { AffiliateService } from '../../../core/services/affiliate.service';
import { ContentService } from '../../../core/services/content.service';
import { MainService } from '../../../core/services/main.service';
import { FooterComponent } from './../../../footer/footer.component';
import { GiftBoxComboItemDetailsComponent } from './combo-item-details/combo-item-details.component';
import { GiftBoxComboListingItemComponent } from './combo-listing-item/combo-listing-item.component';
import { GiftBoxComboListingNavbarComponent } from './combo-listing-navbar/combo-listing-navbar.component';

@Component({
    selector: 'app-gift-box-combo-listing',
	standalone: true,
	imports: [FooterComponent, GiftBoxComboItemDetailsComponent, GiftBoxComboListingItemComponent, TranslocoPipe, GiftBoxComboListingNavbarComponent],
    templateUrl: './combo-listing.component.html',
    styleUrls: ['./combo-listing.component.css'],
})

export class GiftBoxComboListingComponent implements OnInit {

	private contentSlug = 'gift-boxes-valentines-2024';
	
	// TODO: Use this slug to make test products appear on staging, but change to original above before committing!
	// private contentSlug = 'gift-boxes-mtl';

	affiliate: Affiliate;
	selectedProduct: Product;

	//Data
	lists: ListContent;
	products: Product[] = [];

	//UI Variables
	isResolvingSections: boolean = true;
	detailsOpen: boolean = false;
    showFooter: boolean = true;

	//TODO: to ensure that multiple modals don't interfere
	private modalQueue$ = new BehaviorSubject<any>(null);

	constructor(
        private mainService: MainService,
		private contentService: ContentService,
		private affiliateService: AffiliateService,
		public translate: TranslocoService,
		private modalService: NgbModal
	) { }

	ngOnInit(): void {
		this.contentService.fetchList(this.contentSlug).pipe(finalize(() => this.isResolvingSections = false)).subscribe(lists => {
			this.lists = lists;
			if (this.lists) this.products = (this.lists.items[0] as ListContent).items as Product[];
		});
		if (!localStorage.getItem('gift_box_address_verified')) this.modalQueue$.next(this.showAddressVerificationModal);

		if (this.affiliateService.affiliate) {
			this.affiliate = this.affiliateService.affiliate;
			this.modalQueue$.next(this.showAffiliateModal);
		}
		else this.mainService.fetchAffiliate(OrderType.GiftBox).subscribe(affiliate => {
			this.affiliate = affiliate;
			this.modalQueue$.next(this.showAffiliateModal);
		})

		this.modalQueue$.pipe(concatMap(o => o(this))).subscribe();
	}

	listSelected(list: ListContent) {
		this.products = (this.lists.items.find(item => item.slug == list.slug) as ListContent).items as Product[];
	}

	showAddressVerificationModal(ctx: this) {
		let modal = ctx.modalService.open(GiftBoxVerifyAddressModalComponent, { centered: true });
		return modal.closed;
	}

	showAffiliateModal(ctx: this) {
		let modal = ctx.modalService.open(GiftBoxReferralCodeModalComponent, { centered: true });
		modal.componentInstance.affiliate = ctx.affiliate;
		return modal.closed;
	}

	openProductDetails(product : Product) {
		this.detailsOpen = true;
		this.selectedProduct = product;
	}
}
